export default {
  'esrb': ['US', 'CA', 'MX'],
  'pegi': ['FR', 'CZ', 'IT', 'GB'],
  'cob': ['AU', 'NZ'],
  'fpb': ['SA'],
  'ifco': ['IE'],
  'usk': ['DE'],
  'mda': ['SG'],
  'grb': ['KR'],
  'gsr': ['CN', 'TW'],
  '436fz': ['RU'],
};



// WEBPACK FOOTER //
// ./lib/rlink-regions/ratingsBoards.js